import { render, staticRenderFns } from "./alipayAPIConfigure.vue?vue&type=template&id=0d44d1f7&scoped=true"
import script from "./alipayAPIConfigure.vue?vue&type=script&lang=js"
export * from "./alipayAPIConfigure.vue?vue&type=script&lang=js"
import style0 from "./alipayAPIConfigure.vue?vue&type=style&index=0&id=0d44d1f7&prod&scoped=true&lang=css"
import style1 from "./alipayAPIConfigure.vue?vue&type=style&index=1&id=0d44d1f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d44d1f7",
  null
  
)

export default component.exports